import { Component, input } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-stat-card',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <article class="stat-card">
      <div class="stat-card-icon" aria-hidden="true">
        <lucide-icon [name]="icon()" [size]="18" class="stat-card-icon-glyph"></lucide-icon>
      </div>
      <div class="stat-card-body">
        <p class="stat-card-value">{{ displayValue() }}</p>
        <p class="stat-card-label">{{ label() }}</p>
      </div>
    </article>
  `,
  styles: [
    `
      .stat-card {
        border: 1px solid var(--border-subtle);
        border-radius: var(--r-card);
        background: var(--bg-surface);
        padding: var(--space-4) var(--space-4);
        box-shadow: var(--shadow-card);
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        gap: var(--space-4);
        min-height: 88px;
        transition:
          border-color var(--transition-ui),
          box-shadow var(--transition-ui),
          transform var(--transition-fast);
      }

      .stat-card:hover {
        border-color: color-mix(in srgb, var(--border) 70%, var(--accent));
        box-shadow: var(--shadow-hover);
      }

      .stat-card-icon {
        width: 44px;
        height: 44px;
        border-radius: var(--r-pill);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: var(--accent-soft);
        border: 1px solid color-mix(in srgb, var(--accent) 12%, var(--border-subtle));
        color: var(--active-text);
        flex-shrink: 0;
      }

      .stat-card-icon-glyph {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
      }

      .stat-card-body {
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 2px;
      }

      .stat-card-value {
        margin: 0;
        font: var(--font-stat-value);
        letter-spacing: -0.02em;
        color: var(--text);
        font-variant-numeric: tabular-nums;
      }

      .stat-card-label {
        margin: 0;
        font: var(--font-caption);
        color: var(--muted);
        letter-spacing: -0.01em;
      }
    `,
  ],
})
export class StatCardComponent {
  readonly icon = input.required<string>();
  readonly value = input.required<string | number>();
  readonly label = input.required<string>();

  displayValue(): string {
    const v = this.value();
    return typeof v === 'number' ? String(v) : v;
  }
}
